import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home/Home";
import ChatBot from "./components/Header/ChatBot";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import OurServices from "./components/OurServices/OurServices";
import ProjectCaseStudy from "./components/OurServices/ProjectCaseStudy";
import OurTeam from "./components/OurTeam/OurTeam";
// import AutoScrollCarousel from "./components/OurServices/AutoScrollCarousel";

import Blogs from "./components/Blogs/Blogs";
import Blog1 from "./components/Blogs/Blog1";
import Blog2 from "./components/Blogs/Blog2";
import Blog3 from "./components/Blogs/Blog3";
import Blog4 from "./components/Blogs/Blog4";
import Blog5 from "./components/Blogs/Blog5";
import Blog6 from "./components/Blogs/Blog6";
import Blog7 from "./components/Blogs/Blog7";
import Blog8 from "./components/Blogs/Blog8";
import Blog9 from "./components/Blogs/Blog9";
import Blog10 from "./components/Blogs/Blog10";
import Blog11 from "./components/Blogs/Blog11";
import Careers from "./components/Careers/Careers";
import TermsAndConditions from "./components/Terms/TermsAndConditions";
import PrivacyPolicy from "./components/Terms/PrivacyPolicy";

function App() {
  return (
    <div>
      <Router>
        <Header />

        <Suspense
          fallback={
            <div className="flex items-center text-center">Loading...</div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/ChatBot" element={<ChatBot />} />
            <Route path="/services/:serviceLink" element={<OurServices />} />
            <Route
              path="/project-case-study/:caseStudyLink"
              element={<ProjectCaseStudy />}
            />
            <Route path="/about-us" element={<OurTeam />} />
            <Route path="/careers" element={<Careers />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* <Route
              path="/AutoScrollCarousel"
              element={<AutoScrollCarousel />}
            /> */}

            <Route path="/blogs" element={<Blogs />} />
            <Route
              path="/tech-trends-2024-what-s-hot-in-IT"
              element={<Blog1 />}
            />
            <Route
              path="/tech-trends-2024-why-react-is-the-best-choice-for-modern-web-apps"
              element={<Blog2 />}
            />
            <Route
              path="/tech-trends-2024-how-SaaS-is-changing-the-software-industry"
              element={<Blog3 />}
            />
            <Route
              path="/why-businesses-will-benefit-from-AI-powered-web-apps-in-2025"
              element={<Blog4 />}
            />
            <Route
              path="/scaling-a-SaaS-startup-in-2025-key-insights-for-success"
              element={<Blog5 />}
            />
            <Route
              path="/is-shopify-still-the-top-e-commerce-platform-in-2025"
              element={<Blog6 />}
            />
            <Route
              path="/why-react-react-native-still-matter-in-the-AI-era"
              element={<Blog7 />}
            />
            <Route
              path="/genAI-for-SMBs-practical-use-cases-beyond-chatGPT-in-2025"
              element={<Blog8 />}
            />
            <Route
              path="/the-rise-of-fintech-logistics-tech-how-AI-is-powering-indias-shipping-and-wallet-systems"
              element={<Blog9 />}
            />
            <Route
              path="/quantum-computing-is-closer-than-you-think-what-businesses-need-to-prepare-for-now"
              element={<Blog10 />}
            />
            <Route
              path="/why-good-seo-is-not-cheap-and-why-its-worth-every-rupee"
              element={<Blog11 />}
            />
          </Routes>
        </Suspense>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
